import { createCollectionDomainHook } from './domainHookFactory';
import { vectorTilesTranslator } from './translators/vectorTiles';
import type { VectorTileItem } from './types';

export const useVectorTilesSettings =
  createCollectionDomainHook<VectorTileItem>(
    'vector_tiles',
    'tiles',
    vectorTilesTranslator,
  );
